import React from 'react';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-white to-gray-100">
      <div className="bg-brand-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-brand-dark rounded-lg flex items-center justify-center">
                <span className="text-brand-white text-xl font-bold">P</span>
              </div>
              <h1 className="text-2xl font-bold text-brand-dark">Partner & Manager Portal</h1>
            </div>
            <div className="text-sm text-gray-600">
              Professional Management System
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-brand-dark mb-6">
            Welcome to <span className="text-brand-dark">Partner & Manager Hub</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Dedicated workspace for business partners and managers with project management and team collaboration tools
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {/* Partner Card */}
          <div className="bg-brand-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-20 h-20 bg-gradient-to-r from-brand-dark to-gray-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-brand-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2V6m8 0H8m0 0H6m2 0h8" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-brand-dark mb-3">Partner Dashboard</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Manage your team, track queries, view reports, and collaborate with managers
            </p>
            <ul className="text-left text-sm text-gray-600 mb-6 space-y-2">
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Team Management
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Query Tracking
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                PDF Reports
              </li>
            </ul>
            <button
              onClick={() => navigate('/login?role=partner')}
              className="w-full bg-brand-dark text-brand-white py-3 px-6 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
            >
              Sign In as Partner
            </button>
          </div>

          {/* Manager Card */}
          <div className="bg-brand-white rounded-2xl shadow-lg p-8 text-center hover:shadow-xl transition-shadow">
            <div className="w-20 h-20 bg-gradient-to-r from-brand-golden to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg className="w-10 h-10 text-brand-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-brand-dark mb-3">Manager Dashboard</h2>
            <p className="text-gray-600 mb-6 text-sm">
              Oversee your team, handle queries, generate reports, and manage notifications
            </p>
            <ul className="text-left text-sm text-gray-600 mb-6 space-y-2">
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Team Oversight
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Query Management
              </li>
              <li className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                Report Generation
              </li>
            </ul>
            <button
              onClick={() => navigate('/login?role=manager')}
              className="w-full bg-brand-golden text-brand-white py-3 px-6 rounded-lg font-semibold hover:bg-yellow-600 transition-colors"
            >
              Sign In as Manager
            </button>
          </div>
        </div>

        <div className="bg-brand-white py-12 border-t rounded-2xl">
          <div className="max-w-4xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-14 h-14 bg-brand-golden/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-7 h-7 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-brand-dark mb-2">Role-Based Access</h3>
                <p className="text-gray-600 text-sm">Secure access based on your role</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 bg-brand-golden/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-7 h-7 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-brand-dark mb-2">Real-time Updates</h3>
                <p className="text-gray-600 text-sm">Instant notifications and alerts</p>
              </div>
              <div className="text-center">
                <div className="w-14 h-14 bg-brand-golden/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-7 h-7 text-brand-golden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-brand-dark mb-2">Detailed Reports</h3>
                <p className="text-gray-600 text-sm">Comprehensive analytics and PDF exports</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
